export function isExternalUrl(url: string) {
  const matchpattern =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return matchpattern.test(url);
}

export const LOGO_SRC = process.env.PUBLIC_URL + '/images/logo.svg';
export const LOGO_SRC_WHITE = process.env.PUBLIC_URL + '/images/logo_white.svg';
